import { userRole } from "../constants/appConst";

export const getFolderRole = (user, folderId) => {
    if (user?.isGlobalAdmin)
        return userRole.GlobalAdmin;

    const folder = user?.folders?.find(
        x => x.folderIdentifier?.toLowerCase() === folderId?.toLowerCase()
    );

    return folder?.role ?? 0;
};

export const hasFolderRole = (user, folderId, ...roles) => {

    if (user?.isGlobalAdmin)
        return true;

    const role = getFolderRole(user, folderId);

    return roles.includes(role);
};

export const isGlobalAdmin = (user) =>
    user?.isGlobalAdmin === true;

export const canManageUsers = (user) => {
    if (user?.isGlobalAdmin)
        return true;

    return user?.folders?.some(f =>
        f.role === userRole.BusinessUnitAdmin ||
        f.role === userRole.BusinessUnitUserAdministrator
    );
};
export const canCreateRole = (currentUser, targetRole) => {
    if (currentUser?.isGlobalAdmin)
        return true;

    const highestRole = Math.min(
        ...currentUser.folders.map(f => f.role)
    );

    switch (highestRole) {
        case userRole.BusinessUnitAdmin:
            return [
                userRole.BusinessUnitAdmin,
                userRole.BusinessUnitUserAdministrator,
                userRole.BusinessUnitUser
            ].includes(targetRole);

        case userRole.BusinessUnitUserAdministrator:
            return [
                userRole.BusinessUnitUserAdministrator,
                userRole.BusinessUnitUser
            ].includes(targetRole);

        default:
            return false;
    }
};